/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React from 'react';
import { Stack, Button } from '@mui/material';
import { reportWarningImage, reportErrorImage } from '../../shared/assets/images';
import './report.scss';
import { fatalMarkersData, warningMarkerData } from '../../shared/constantVariable';

function Reportunitop(props) {
  const { error_details_info, error_unitop_info, report_visibility } = props;
  const error_info = error_details_info.filter(d => d.name === error_unitop_info);
  // const warning = error_info[0] ? (error_info[0].data.length > 0 ? error_info[0].data.filter(d => d.toLowerCase().indexOf('warning') === 0) : 0) : 0;
  const warning = error_info[0] && error_info[0].data.length > 0
    ? error_info[0].data.filter(d =>
      warningMarkerData.some(marker =>
        d.toLowerCase().includes(marker.toLowerCase())
      )
    )
    : [];
  // const errors = error_info[0] ? (error_info[0].data.length > 0 ? error_info[0].data.filter(d => d.toLowerCase().indexOf('fatal error') === 0) : 0) : 0;
  const errors = error_info[0] && error_info[0].data.length > 0
    ? error_info[0].data.filter(d =>
      fatalMarkersData.some(marker =>
        d.toLowerCase().startsWith(marker.toLowerCase())
      )
    )
    : [];
  const warning_fun = (event) => {
    report_visibility(event, true);
  };
  return (
    <div className="unitop-error-icon-div hide-close">
      <Stack direction="row" spacing={2}>
        {warning.length !== 0 &&
          <Button variant="outlined" onClick={warning_fun} startIcon={<img src={reportWarningImage} alt='units' className="error-icon" />}>
            {warning.length}
          </Button>
        }
        {errors.length !== 0 &&
          <Button variant="outlined" onClick={warning_fun} className='left_warning'
            startIcon={<img src={reportErrorImage} alt='units' className="error-icon" />}>
            {errors.length}
          </Button>}
      </Stack>
    </div>
  );
}

export default Reportunitop;